// Select relevant elements
const canHolders = document.querySelectorAll('.tcw-can-holder');
const canContents = document.querySelectorAll('.tcw-can-content');
const canSectionBottom = document.querySelector('.tcw-can-section-bottom');

canHolders.forEach((holder) => {
  holder.addEventListener('mouseenter', () => {

    canHolders.forEach((el) => el.classList.remove('active'));
    canContents.forEach((el) => el.classList.remove('active'));
    holder.classList.add('active');

    const index = holder.getAttribute('data-index');
    const matchingContent = document.querySelector(`.tcw-can-content[data-index="${index}"]`);
    
    if (matchingContent) {
      matchingContent.classList.add('active');
    }

    if (canSectionBottom) {
      canSectionBottom.className = canSectionBottom.className
        .split(' ')
        .filter((cls) => !cls.startsWith('active'))
        .join(' ');

      canSectionBottom.classList.add(index === "0" ? "active" : `active-${index}`);
    }
  });
});
